(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["scrolling_banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
	const buttons = document.querySelectorAll('.scrolling_content_actions .btn');
	if (!buttons.length) return;
	buttons.forEach((btn) => {
		btn.addEventListener('click', (e) => {
			e.preventDefault();
			const targetClass = btn.dataset.target;
			const targetEl = document.querySelector(`${targetClass}`);
			if (!targetEl) return;
			buttons.forEach((b) => b.classList.remove('active'));
			buttons.forEach((b) => {
				const el = document.querySelector(`${b.dataset.target}`);
				if (el) el.style.display = 'none';
			});
			btn.classList.add('active');
			targetEl.style.display = 'block';
			targetEl.scrollIntoView({
				behavior: 'smooth',
				block: 'start'
			});
		});
	});
});

  } catch(e) { console.error(e); }
})();
})();
